export function validatePhoneNumber(phoneNumber: string): boolean {
  const cleaned = phoneNumber.replace(/[^\d+]/g, "");
  const regex = /^(7|8)\d{10}$/;
  if (!regex.test(cleaned)) return false;
  const operatorCodes = ["9", "4", "8"];
  return operatorCodes.includes(cleaned.charAt(1));
}
